import { checkEmail, hideInvalidEmail } from '.'
import { GIFT_IMAGE, POPUP_ENRICH_DATA_TRACKING_CODE } from '../../Constants'
import sendTrackingData from '../../Functions/sendTrackingData'
import { closePopup, showPopup } from '../../Functions/sendTrackingEvents'
import { getTrackingId, randomNumber } from '../../Utils'
import { hideMinimized } from './DefaultPage'
import { generateResultPage } from './ResultPage'

const renderGiftBoxes = (gifts) => {
  if (!gifts) return
  const gs = gifts
    .map(() => `<img src=${GIFT_IMAGE} alt="gift image" class="kariba-gift-item"/>`)
    .join('')

  return `<div class="kariba-gift-wrapper">${gs}</div>`
}

const showMinimized = () => {
  let minimized = document.getElementById('kariba_random_gift_minimize')
  minimized.className = 'show-class'
}

const hideOverlay = (node_uuid) => {
  let overlayLayer = document.getElementById('kariba_overlay_container')
  overlayLayer.className = 'hide-class'
  const count = closePopup(node_uuid, () => {
    document.getElementById('kariba_random_gift_minimize')?.remove()
    document.getElementById('kariba_overlay_container')?.remove()
  })
}

export const showResultPage = (data = {}, email, node_uuid) => {
  // console.log('data: ', data)
  const trackingId = getTrackingId()
  const gifts = data?.mainPopup?.gift?.gifts || []
  // console.log('gifts: ', gifts)
  const randomGift = gifts[randomNumber(0, gifts.length - 1)]

  generateResultPage(data.result, randomGift)
  sendTrackingData(POPUP_ENRICH_DATA_TRACKING_CODE, {
    email,
    utm_s: data?.email?.emailData?.utm_source,
    utm_m: data?.email?.emailData?.utm_medium,
    utm_c: data?.email?.emailData?.utm_campaign,
    coupon: randomGift.code,
    node_uuid: node_uuid,
    popup_t: 1, // 'random_gift' -> 1 | 'default_code' -> 2 | 'spin_game' -> 3
  })

  const valueSubmit = {
    tracking_id: trackingId,
    node_uuid: node_uuid,
    coupon_code: randomGift.code,
    email: email,
  }
  const mess = submitMinigame(valueSubmit)
}

export const generateMainContent = (data = {}, node_uuid) => {
  const { mainPopup } = data
  const giftImage = mainPopup?.imgGift?.url || ''
  const giftImages = mainPopup?.imgGifts?.url || ''
  const title = mainPopup?.text?.content || ''
  const titleStyle = mainPopup?.text?.style || {}
  const text_1 = mainPopup?.text_1?.content || ''
  const text_1Style = mainPopup?.text_1?.style || {}
  const text_2 = mainPopup?.text_2?.content || ''
  const text_2Style = mainPopup?.text_2?.style || {}
  const inputPlaceholder = mainPopup?.input?.content || ''
  const inputStyle = mainPopup?.input?.style || {}
  const buttonText = mainPopup?.button?.content || ''
  const buttonStyle = mainPopup?.button?.style || {}
  const email_style = mainPopup?.email?.style || {}

  const html = `
      <div id="kariba_input_container" style="
        width: 336px;
        min-height: 408px;
        background-color: #F0F5FF;
        align-self: center;
        justify-self:center;
        position:absolute"
      >
        <div id="kariba_close_random_gift" style="
          color: #6C6C6C; 
          font-size: 20px;
          cursor: pointer;
          justify-self:center;
          top: 12px;
          right: 18px;
          position: absolute;"
        ><i class="material-icons">&#xe5cd;</i></div>
        <img src=${giftImage} alt="gift image" class="kariba-image-decorator" />
        <span style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
            color: ${titleStyle.color || '#FA541C'};
            font-size: ${titleStyle.fontSize || 36}px;
            font-weight: ${titleStyle.fontStyle || 'bold'};
            text-align: ${titleStyle.textAlign || 'left'};
            line-height: 36px;
        ">${title}</span>
        <span style="font-family: ${text_1Style.fontFamily || 'Inter'}; 
          color: ${text_1Style.color || '#FA541C'};
          font-size: ${text_1Style.fontSize || 20}px;
          font-weight: ${text_1Style.fontStyle || 'bold'};
          text-align: ${text_1Style.textAlign || 'left'};
          margin-bottom: 12px;
          ">${text_1}</span>
          
        <span style="font-family: ${text_2Style.fontFamily || 'Inter'}; 
          color: ${text_2Style.color || '#FA541C'};
          font-size: ${text_2Style.fontSize || 14}px;
          font-weight: ${text_2Style.fontStyle || 'bold'};
          text-align: ${text_2Style.textAlign || 'center'};
          margin-bottom: 8px;
          ">${text_2}</span>
        <input
          id='kariba_minigame_email'
          placeholder='${inputPlaceholder || 'Enter email'}'
          style="font-family: ${inputStyle.fontFamily || 'Inter'}; 
            color: ${inputStyle.color || '#000'};
            font-size: ${inputStyle.fontSize || 14}px;
            font-weight: ${inputStyle.fontStyle || 'nomal'};
            text-align: ${inputStyle.textAlign || 'left'};
            width:262px;
            height:40px;
            border-radius:4px;
            padding: 9px 15px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            align-self: center;
            border: 1px solid #CCC;"
        />
          <div 
            id="alert_email" 
            style="width: 264px;
            font-family: ${email_style.fontFamily || 'Inter'};
            color: ${email_style.color || '#F5222D'};
            font-size: ${email_style.fontSize || 22}px;
            font-weight: ${email_style.fontStyle || 'normal'};
            text-align: ${email_style.textAlign || 'left'};
            display:none; 
            padding-right:42px; 
            align-self: center;">Email bạn nhập vào không hợp lệ</div>
          ${renderGiftBoxes(mainPopup?.gift?.gifts)}
        </div>`

  let formContent = document.getElementById('kariba_input_container')
  formContent.innerHTML += html
  showPopup(node_uuid)

  let closeDefaultCode = document.getElementById('kariba_close_random_gift')
  closeDefaultCode.addEventListener('click', () => {
    showMinimized()
    hideOverlay(node_uuid)
  })

  const emailInput = document.getElementById('kariba_minigame_email')

  document.addEventListener('click', async function (event) {
    if (event.target.className === 'kariba-gift-item') {
      hideInvalidEmail()
      const isEmailValid = await checkEmail(emailInput, node_uuid)
      if (!isEmailValid) return
      event.target.classList.add('kariba-swing')
      setTimeout(() => {
        hideMinimized()
        hideOverlay()
        showResultPage(data, emailInput?.value, node_uuid)
      }, 1700)
    }
  })
}
